export type OutageVariant = 'planned' | 'unplanned';

export interface OutagePageConfig {
    isActive: boolean;
    variant: OutageVariant;
    appName: string;
    planned: {
        startDate: string;
        endDate: string;
    };
}

export const OUTAGE_PAGE_CONFIG: OutagePageConfig = {
  isActive: false,
  variant: "planned",
  appName: "Sage Sync",
  planned: {
    startDate: "Saturday, April 25 at 6:00 AM CST",
    endDate: "Sunday, April 26 at 11:59 PM CST",
  },
};
